import React from 'react';
import { Target } from 'lucide-react';

export function QuestMockup() {
  const acts = [
    { name: 'Acte I — L\'Appel', status: 'completed' },
    { name: 'Acte II — La Descente', status: 'in_progress' },
    { name: 'Acte III — Le Boss Final', status: 'pending' },
  ];
  const statusColors = { completed: 'bg-green-500', in_progress: 'bg-yellow-500', pending: 'bg-muted-foreground/30' };

  return (
    <div className="landing-mockup-card">
      <div className="flex items-center gap-2 mb-1">
        <Target className="h-4 w-4 text-amber-400" />
        <span className="font-cinzel text-xs font-bold">La Malédiction de Valdris</span>
      </div>
      <div className="flex gap-1 mb-3">
        <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-amber-500/20 text-amber-400">Quête principale</span>
        <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-yellow-500/20 text-yellow-400">En cours</span>
      </div>
      <div className="space-y-1.5">
        {acts.map((act, i) => (
          <div key={i} className="flex items-center gap-2 text-[11px]">
            <div className={`w-2.5 h-2.5 rounded-full ${statusColors[act.status]} ${act.status === 'in_progress' ? 'animate-pulse' : ''}`} />
            <span className={act.status === 'completed' ? 'text-muted-foreground line-through' : 'text-foreground'}>{act.name}</span>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-2 text-[10px] text-muted-foreground">
        <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-green-500 to-yellow-500 rounded-full" style={{ width: '50%' }} />
        </div>
        <span>2/4 objectifs</span>
      </div>
    </div>
  );
}
